export default class RequestCreateRequest {
  /**
   *
   * @param {number} userId l'identifiant de l'utilisateur
   * @param {AppointmentCreateRequest[]} appointments
   * @param {number} nbEquipments
   * @param {boolean} specialRequest : indique si nous sommes dans une demande spéciale
   */
  constructor({
                userId,
                appointments = [],
                nbEquipments,
                specialRequest,
              }) {
    this.userId = userId
    this.appointments = appointments
    this.nbEquipments = nbEquipments
    this.specialRequest = specialRequest
  }
}
